module.exports = __webpack_public_path__ + "static/relaunch-mobile-62a5e343d6c056147a15a28a59d3d9df.jpg";